<template>
  <div class="content" v-bind:class="[{ 's-full-list-active': fullListActive}]">
    <h1>The <span>12 Seattle neighborhoods</span> between <span>{{startDate}}</span> and <span>{{endDate}}</span> with the <strong>highest</strong>...</h1>

    <div class="well collisions-filters">
      <h2 class="well-title collisions-filters-title">
        <span>Filter collisions</span>
      </h2>
      <div class="well-content">
        <FilterDate :default-option="{ key: 'all', label: 'Since January 1st, 2006' }"></FilterDate>
        <FilterSubmitButton :routeName="'neighborhoodRanks'" 
                            :routeParams="routeParams" 
                            v-bind:class="[{'is-loading': isLoading}]"></FilterSubmitButton>
      </div>
    </div>

    <div class="l-grid l-grid-medium">
        <Costs :card-color="'green'"
               :card-icon="'attach_money'"
               :full-list-toggle-dispatch="'neighborhoodRanksView/fullList/toggleActive'"
               :full-list-options-dispatch="'neighborhoodRanksView/fullList/setOptions'"
               :full-list-options="{ apiSlug: '/neighborhood/ranks/costs/economic/desc',
                                     pageTitle: 'Seattle economic costs by neighborhood between ' + startDate + ' &amp; ' + endDate,
                                     title: 'Economic costs',
                                     ths: ['Rank', 'Neighborhood', 'Amount'],
                                     link: 'neighborhood',
                                     titleIcon: 'attach_money',
                                     color: 'green',
                                     prefix: '$',
                                     barColors: this.$store.getters.green.light.a
                                  }"
               :getter="'neighborhoodRanksView/costs/get'"
               :title="'Economic costs'"
               :bar-color="this.$store.getters.green.light.a"
               :legend-color="'green'"
               :legend-link="'neighborhood'"
               :label-prefix="' $'"></Costs>

        <TotalCollisions :card-color="'yellow'"
               :card-icon="'flare'"
               :full-list-toggle-dispatch="'neighborhoodRanksView/fullList/toggleActive'"
               :full-list-options-dispatch="'neighborhoodRanksView/fullList/setOptions'"
               :full-list-options="{ apiSlug: '/neighborhood/ranks/totalcollisions/desc',
                                     pageTitle: 'Seattle total collisions by neighborhood between ' + startDate + ' &amp; ' + endDate,
                                     title: 'Total collisions',
                                     ths: ['Rank', 'Neighborhood', 'Amount'],
                                     link: 'neighborhood',
                                     titleIcon: 'warning',
                                     color: 'yellow',
                                     barColors: this.$store.getters.yellow.default
                                   }"
               :getter="'neighborhoodRanksView/totalCollisions/get'"
               :title="'Total collisions'"
               :bar-color="this.$store.getters.yellow.default"
               :legend-color="'yellow'"
               :legend-link="'neighborhood'"></TotalCollisions>

        <Fatalities :card-color="'black'"
               :full-list-toggle-dispatch="'neighborhoodRanksView/fullList/toggleActive'"
               :full-list-options-dispatch="'neighborhoodRanksView/fullList/setOptions'"
               :full-list-options="{ apiSlug: '/neighborhood/ranks/severity/5/desc',
                                     pageTitle: 'Seattle fatalities by neighborhood between ' + startDate + ' &amp; ' + endDate,
                                     title: 'Fatalities',
                                     ths: ['Rank', 'Neighborhood', 'Amount'],
                                     link: 'neighborhood',
                                     color: 'black',
                                     barColors: this.$store.getters.black.dark.b
                                   }"
               :getter="'neighborhoodRanksView/fatalities/get'"
               :title="'Fatalities'"
               :bar-color="this.$store.getters.black.dark.b"
               :legend-color="'black'"
               :legend-link="'neighborhood'"></Fatalities>

        <SeriousInjuries :card-color="'red'"
               :full-list-toggle-dispatch="'neighborhoodRanksView/fullList/toggleActive'"
               :full-list-options-dispatch="'neighborhoodRanksView/fullList/setOptions'"
               :full-list-options="{ apiSlug: '/neighborhood/ranks/severity/4/desc',
                                     pageTitle: 'Seattle serious injuries by neighborhood between ' + startDate + ' &amp; ' + endDate,
                                     title: 'Serious injuries',
                                     ths: ['Rank', 'Neighborhood', 'Amount'],
                                     link: 'neighborhood',
                                     color: 'red',
                                     barColors: this.$store.getters.red.dark.b
                                   }"
               :getter="'neighborhoodRanksView/seriousInjuries/get'"
               :title="'Number of serious injuries'"
               :bar-color="this.$store.getters.red.dark.b"
               :legend-color="'red'"
               :legend-link="'neighborhood'"></SeriousInjuries>

        <Injuries :card-color="'red'"
               :full-list-toggle-dispatch="'neighborhoodRanksView/fullList/toggleActive'"
               :full-list-options-dispatch="'neighborhoodRanksView/fullList/setOptions'"
               :full-list-options="{ apiSlug: '/neighborhood/ranks/severity/1/desc',
                                     pageTitle: 'Seattle injuries by neighborhood between ' + startDate + ' &amp; ' + endDate,
                                     title: 'Injuries',
                                     ths: ['Rank', 'Neighborhood', 'Amount'],
                                     link: 'neighborhood',
                                     color: 'red',
                                     barColors: this.$store.getters.red.dark.a
                                   }"
               :getter="'neighborhoodRanksView/injuries/get'"
               :title="'Number of injuries'"
               :bar-color="this.$store.getters.red.dark.a"
               :legend-color="'red'"
               :legend-link="'neighborhood'"></Injuries>

        <PossibleInjuries :card-color="'red'"
               :full-list-toggle-dispatch="'neighborhoodRanksView/fullList/toggleActive'"
               :full-list-options-dispatch="'neighborhoodRanksView/fullList/setOptions'"
               :full-list-options="{ apiSlug: '/neighborhood/ranks/severity/3/desc',
                                     pageTitle: 'Seattle possible injuries by neighborhood between ' + startDate + ' &amp; ' + endDate,
                                     title: 'possible injuries',
                                     ths: ['Rank', 'Neighborhood', 'Amount'],
                                     link: 'neighborhood',
                                     color: 'red',
                                     barColors: this.$store.getters.red.light.b
                                   }"
               :getter="'neighborhoodRanksView/possibleInjuries/get'"
               :title="'Collisions with possible injuries'"
               :bar-color="this.$store.getters.red.light.b"
               :legend-color="'red'"
               :legend-link="'neighborhood'"></PossibleInjuries>

        <PeopleInvolved :card-color="'orange'"
               :card-icon="'person'"
               :full-list-toggle-dispatch="'neighborhoodRanksView/fullList/toggleActive'"
               :full-list-options-dispatch="'neighborhoodRanksView/fullList/setOptions'"
               :full-list-options="{ apiSlug: '/neighborhood/ranks/who/personcount/desc',
                                     pageTitle: 'Seattle people involved by neighborhood between ' + startDate + ' &amp; ' + endDate,
                                     title: 'People involved',
                                     ths: ['Rank', 'Neighborhood', 'Amount'],
                                     link: 'neighborhood',
                                     color: 'orange',
                                     barColors: this.$store.getters.orange.dark.a
                                   }"
               :getter="'neighborhoodRanksView/possibleInjuries/get'"
               :title="'Number of people involved'"
               :bar-color="this.$store.getters.orange.dark.a"
               :legend-color="'orange'"
               :legend-link="'neighborhood'"></PeopleInvolved>
        
        <PeopleWalking :card-color="'orange'"
               :card-icon="'directions_walk'"
               :full-list-toggle-dispatch="'neighborhoodRanksView/fullList/toggleActive'"
               :full-list-options-dispatch="'neighborhoodRanksView/fullList/setOptions'"
               :full-list-options="{ apiSlug: '/neighborhood/ranks/who/pedcount/desc',
                                     pageTitle: 'Seattle pedestrians involved by neighborhood between ' + startDate + ' &amp; ' + endDate,
                                     title: 'Pedestrians involved',
                                     ths: ['Rank', 'Neighborhood', 'Amount'],
                                     link: 'neighborhood',
                                     color: 'orange',
                                     barColors: this.$store.getters.orange.light.a
                                   }"
               :getter="'neighborhoodRanksView/peopleWalking/get'"
               :title="'Number of pedestrians involved'"
               :bar-color="this.$store.getters.orange.light.a"
               :legend-color="'orange'"
               :legend-link="'neighborhood'"></PeopleWalking>

        <PeopleBiking :card-color="'orange'"
               :card-icon="'directions_bike'"
               :full-list-toggle-dispatch="'neighborhoodRanksView/fullList/toggleActive'"
               :full-list-options-dispatch="'neighborhoodRanksView/fullList/setOptions'"
               :full-list-options="{ apiSlug: '/neighborhood/ranks/who/pedcylcount/desc',
                                     pageTitle: 'Seattle people biking by neighborhood between ' + startDate + ' &amp; ' + endDate,
                                     title: 'People biking',
                                     ths: ['Rank', 'Neighborhood', 'Amount'],
                                     link: 'neighborhood',
                                     color: 'orange',
                                     barColors: this.$store.getters.orange.light.b
                                   }"
               :getter="'neighborhoodRanksView/peopleBiking/get'"
               :title="'Number of people biking involved'"
               :bar-color="this.$store.getters.orange.light.b"
               :legend-color="'orange'"
               :legend-link="'neighborhood'"></PeopleBiking>

        <DistractedDriving :card-color="'purple'"
               :card-icon="'visibility_off'"
               :full-list-toggle-dispatch="'neighborhoodRanksView/fullList/toggleActive'"
               :full-list-options-dispatch="'neighborhoodRanksView/fullList/setOptions'"
               :full-list-options="{ apiSlug: '/neighborhood/ranks/who/inattentionind/desc',
                                     pageTitle: 'Seattle distracted driving by neighborhood between ' + startDate + ' &amp; ' + endDate,
                                     title: 'Distracted driving',
                                     ths: ['Rank', 'Neighborhood', 'Amount'],
                                     link: 'neighborhood',
                                     color: 'purple',
                                     barColors: this.$store.getters.purple.dark.a
                                   }"
               :getter="'neighborhoodRanksView/distractedDriving/get'"
               :title="'Cases of distracted driving'"
               :bar-color="this.$store.getters.purple.dark.a"
               :legend-color="'purple'"
               :legend-link="'neighborhood'"></DistractedDriving>

        <UnderTheInfluence :card-color="'purple'"
               :card-icon="'blur_on'"
               :full-list-toggle-dispatch="'neighborhoodRanksView/fullList/toggleActive'"
               :full-list-options-dispatch="'neighborhoodRanksView/fullList/setOptions'"
               :full-list-options="{ apiSlug: '/neighborhood/ranks/who/underinfl/desc',
                                     pageTitle: 'Seattle DUI by neighborhood between ' + startDate + ' &amp; ' + endDate,
                                     title: 'Driving under the influence',
                                     ths: ['Rank', 'Neighborhood', 'Amount'],
                                     link: 'neighborhood',
                                     color: 'purple',
                                     barColors: this.$store.getters.purple.light.a
                                   }"
               :getter="'neighborhoodRanksView/underTheInfluence/get'"
               :title="'Cases of DUI'"
               :bar-color="this.$store.getters.purple.light.a"
               :legend-color="'purple'"
               :legend-link="'neighborhood'"></UnderTheInfluence>
        
        <PropertyDamageOnly :card-color="'blue'"
               :card-icon="'toll'"
               :full-list-toggle-dispatch="'neighborhoodRanksView/fullList/toggleActive'"
               :full-list-options-dispatch="'neighborhoodRanksView/fullList/setOptions'"
               :full-list-options="{ apiSlug: '/neighborhood/ranks/severity/2/desc',
                                     pageTitle: 'Seattle property damage only by neighborhood between ' + startDate + ' &amp; ' + endDate,
                                     title: 'Property damage only',
                                     ths: ['Rank', 'Neighborhood', 'Amount'],
                                     link: 'neighborhood',
                                     color: 'blue',
                                     barColors: this.$store.getters.blue.light.a
                                   }"
               :getter="'neighborhoodRanksView/propertyDamageOnly/get'"
               :title="'Property damage only collisions'"
               :bar-color="this.$store.getters.blue.light.a"
               :legend-color="'blue'"
               :legend-link="'neighborhood'"></PropertyDamageOnly>

        <ParkedCarsHit :card-color="'blue'"
               :card-icon="'local_parking'"
               :full-list-toggle-dispatch="'neighborhoodRanksView/fullList/toggleActive'"
               :full-list-options-dispatch="'neighborhoodRanksView/fullList/setOptions'"
               :full-list-options="{ apiSlug: '/neighborhood/ranks/who/hitparkedcar/desc',
                                     pageTitle: 'Seattle parked cars hit by neighborhood between ' + startDate + ' &amp; ' + endDate,
                                     title: 'Parked cars hit',
                                     ths: ['Rank', 'Neighborhood', 'Amount'],
                                     link: 'neighborhood',
                                     color: 'blue',
                                     barColors: this.$store.getters.blue.light.a
                                   }"
               :getter="'neighborhoodRanksView/parkedCarsHit/get'"
               :title="'Number of parked cars hit'"
               :bar-color="this.$store.getters.blue.light.a"
               :legend-color="'blue'"
               :legend-link="'neighborhood'"></ParkedCarsHit>

        <Speeding :card-color="'teal'"
               :card-icon="'fast_forward'"
               :full-list-toggle-dispatch="'neighborhoodRanksView/fullList/toggleActive'"
               :full-list-options-dispatch="'neighborhoodRanksView/fullList/setOptions'"
               :full-list-options="{ apiSlug: '/neighborhood/ranks/who/speeding/desc',
                                     pageTitle: 'Seattle speeding by neighborhood between ' + startDate + ' &amp; ' + endDate,
                                     title: 'Speeding',
                                     ths: ['Rank', 'Neighborhood', 'Amount'],
                                     link: 'neighborhood',
                                     color: 'teal',
                                     barColors: this.$store.getters.teal.light.a
                                   }"
               :getter="'neighborhoodRanksView/speeding/get'"
               :title="'Cases of speeding'"
               :bar-color="this.$store.getters.teal.light.a"
               :legend-color="'teal'"
               :legend-link="'neighborhood'"></Speeding>
    </div>

    <FullList :getters="{ active: 'neighborhoodRanksView/fullList/active',
                          fetch: 'neighborhoodRanksView/fullList/fetch',
                          filters: 'neighborhoodRanksView/fullList/filters',
                          filterParams: 'neighborhoods=all',
                          get: 'neighborhoodRanksView/fullList/get',
                          options: 'neighborhoodRanksView/fullList/options',
                          reset: 'neighborhoodRanksView/fullList/reset',
                          toggleActive: 'neighborhoodRanksView/fullList/toggleActive'
                        }"></FullList>
  </div>
</template>

<script>
import Moment from 'moment'

import FilterDate from '@/components/FilterDate'
import FilterSubmitButton from '@/components/FilterSubmitButton'
import Ranks from '@/components/barCharts/Ranks'
import FullList from '@/components/trays/FullList'

export default {
  name: 'neighborhoodRanks',

  data: function () {
    return {
      dateToggleLabel: 'Custom date range'
    }
  },

  components: {
    'FilterDate': FilterDate,
    'FilterSubmitButton': FilterSubmitButton,
    'Costs': Ranks,
    'TotalCollisions': Ranks,
    'Fatalities': Ranks,
    'SeriousInjuries': Ranks,
    'Injuries': Ranks,
    'PossibleInjuries': Ranks,
    'PeopleInvolved': Ranks,
    'PeopleWalking': Ranks,
    'PeopleBiking': Ranks,
    'DistractedDriving': Ranks,
    'UnderTheInfluence': Ranks,
    'PropertyDamageOnly': Ranks,
    'ParkedCarsHit': Ranks,
    'Speeding': Ranks,
    'FullList': FullList
  },

  mounted: function () {
    this.$store.dispatch('neighborhoodRanksView/resetResults')
    this.$store.dispatch('neighborhoodRanksView/setFilters')
    this.$store.dispatch('neighborhoodRanksView/fetchAll', this.filters)
  },

  computed: {
    filters () {
      return this.$store.getters['neighborhoodRanksView/filters']
    },

    startDate () {
      return Moment(this.resultsFilters.startDate).format('MMMM Do, YYYY')
    },

    endDate () {
      return Moment(this.resultsFilters.endDate).format('MMMM Do, YYYY')
    },

    routeParams () {
      return {sd: this.filters.startDate, ed: this.filters.endDate}
    },

    resultsFilters () {
      return this.$store.getters['neighborhoodRanksView/resultsFilters']
    },

    isLoading () {
      return (this.$store.getters['neighborhoodRanksView/costs/get'].length > 0) ? 0 : 1
    },

    fullListActive () {
      return this.$store.getters['neighborhoodRanksView/fullList/active']
    }
  },

  watch: {
    $route: function (to, from) {
      this.$store.dispatch('neighborhoodRanksView/resetResults')
      this.$store.dispatch('neighborhoodRanksView/setFilters')
      this.$store.dispatch('neighborhoodRanksView/fetchAll', this.filters)
    }
  }
}
</script>

<style lang="scss">
@import "./src/sass/components/FilterSubmitButton.scss";
@import "./src/sass/views/neighborhood-ranks.scss";
</style>



// WEBPACK FOOTER //
// NeighborhoodRanks.vue?9ce51bb8